import React from 'react';
import FormWithoutBundleContainer from './components/form-without-bundle/form-without-bundle-container';
import type { FormValues } from './components/form-without-bundle/form-without-bundle-container';

export interface ContactDetailsStepProps {
  onFormValuesChange?: (values: FormValues) => void;
  initialValues?: FormValues;
}

const ContactDetailsStep = ({ onFormValuesChange, initialValues }: ContactDetailsStepProps) => {
  const renderFormWithoutBundle = true;
  return (
    <div className='contact-details-step-container'>
      {renderFormWithoutBundle ? (
          <FormWithoutBundleContainer onFormValuesChange={onFormValuesChange} initialValues={initialValues} />
      ) : (
        <div className='contact-details-step-form-with-bundle'>
          <h1>Contact Details Step with bundle</h1>
        </div>
      )}
    </div>
  );
};
export type { FormValues };
export default ContactDetailsStep;